import { useEffect } from 'react'

/**
 * Hook that detects clicks outside of the provided ref elements.
 *
 * @param {React.RefObject[]} refs - Array of refs to treat as "inside" elements
 * @param {Function} onClickOutside - Callback fired when a click lands outside all refs
 * @param {boolean} [enabled=true] - Whether the listener is active
 */
const useClickOutside = (refs, onClickOutside, enabled = true) => {
    useEffect(() => {
        if (!enabled) return

        const handleMouseDown = e => {
            const isInside = refs.some(ref => ref.current && ref.current.contains(e.target))

            if (!isInside) {
                onClickOutside(e)
            }
        }

        document.addEventListener('mousedown', handleMouseDown)
        return () => document.removeEventListener('mousedown', handleMouseDown)
    }, [refs, onClickOutside, enabled])
}

export default useClickOutside
